const KEY = "vms_recent_machines";
const MAX = 8;

/** Small localStorage log of recently opened machines – used by the mobile «Ny rapport» drawer. */
export const getRecentMachines = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const rememberMachine = (m) => {
  if (!m?.id) return;
  try {
    const entry = { id: m.id, label: m.label || [m.brand, m.type].filter(Boolean).join(" "), customer_name: m.customer_name || "", at: Date.now() };
    const next = [entry, ...getRecentMachines().filter((x) => x.id !== m.id)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    /* ignore quota / private mode */
  }
};
